import { render, staticRenderFns } from "./GameBg.vue?vue&type=template&id=fcccab44&scoped=true&"
import script from "./GameBg.vue?vue&type=script&lang=js&"
export * from "./GameBg.vue?vue&type=script&lang=js&"
import style0 from "./GameBg.vue?vue&type=style&index=0&id=fcccab44&lang=scss&scoped=true&"
import style1 from "./GameBg.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcccab44",
  null
  
)

component.options.__file = "GameBg.vue"
export default component.exports